import type { Edit } from "./types";

export const edits: readonly Edit[] = [];
